import Vue from 'vue';
import jsonToFormData from 'json-form-data';
import DOMPurify from 'dompurify';

export default class FormUtils {
  static loadItemData (instance, config) {
    if (!config.id) {
      instance.id = parseInt(instance.$route.params.id, 10);
    } else {
      instance.id = parseInt(config.id, 10);
    }

    if (config.id === null) {
      instance.id = '';
    }

    if (!config.params) {
      config.params = {};
    }

    instance.$http.post(config.endpointBase + instance.id, config.params).then(response => {
      if (response.data) {
        for (let i = 0; i < config.instanceFields.length; i++) {
          let fieldName = config.instanceFields[i];

          if (config.booleanFields && config.booleanFields.indexOf(fieldName) !== -1) {
            instance.data[fieldName] = !!response.data.data[fieldName];
          } else {
            instance.data[fieldName] = response.data.data[fieldName];
          }
        }

        if (config.loadedKey) {
          instance[config.loadedKey] = true;
        }

        if (config.successAction) {
          config.successAction(response.data.data);
        }
      } else {
        // eslint-disable-next-line
        if (config.errorKey) {
          instance[config.errorKey] = true;
        } else {
          instance.loadError = true;
        }
      }
    }).catch(error => {
      console.log(error);

      if (config.errorKey) {
        instance[config.errorKey] = true;
      } else {
        instance.loadError = true;
      }

      if (config.failAction) {
        config.failAction(error);
      }
    });
  }

  static loadAdditionalData (instance, config) {
    instance.$http.post(config.endpoint, config.params).then(response => {
      if (config.lastRequestID !== instance[config.lastRequestIdKey]) {
        console.warn('Race condition detected');
        return;
      }

      if (!response.data && config.errorKey) {
        instance[config.errorKey] = true;
        return;
      }

      let responseData;

      if (config.noPagination) {
        // eslint-disable-next-line
        if (config.responseKey) {
          responseData = response.data[config.responseKey];
        } else {
          responseData = response.data;
        }
      } else {
        // eslint-disable-next-line
        if (config.responseKey) {
          responseData = response.data.data[config.responseKey];
        } else {
          responseData = response.data.data;
        }
      }

      if (config.wrapResponseIntoArray) {
        responseData = [responseData];
      }

      // eslint-disable-next-line
      if (config.outputKeyIndex) {
        instance[config.outputKey][config.outputKeyIndex] = responseData;
      } else if (config.outputKey) {
        instance[config.outputKey] = responseData;
      }

      if (config.loadedKey) {
        instance[config.loadedKey] = true;
      }

      if (config.successAction) {
        config.successAction(responseData);
      }
    }).catch(error => {
      console.log(error);

      if (config.errorKey) {
        instance[config.errorKey] = true;
      }

      if (config.failAction) {
        config.failAction(error);
      }
    });
  }

  static validate (formRef, successAction) {
    formRef.validate().then(result => {
      if (result) {
        successAction();
      }
    });
  }

  static submit (config, imageFields = false) {
    if (!imageFields) {
      config.$http.post(
        config.endpoint,
        config.formData
      ).then(response => {
        if (response.data.success) {
          FormUtils.submitShowSuccess(config, response);
        } else {
          FormUtils.submitShowError(config, response);
        }
      }).catch(error => {
        console.log(error);
        FormUtils.submitShowError(config, error.response);
      });
    } else {
      config.$http.request({
        method: 'POST',
        url: config.endpoint,
        headers: { 'Content-Type': undefined },
        transformRequest: (data) => {
          let dataToSend = jsonToFormData(config.formData);

          for (let i = 0; i < imageFields; i++) {
            dataToSend.append(imageFields[i], data[imageFields[i]]);
          }

          return dataToSend;
        },
        data: config.formData
      }).then(response => {
        if (response.data.success) {
          FormUtils.submitShowSuccess(config, response);
        } else {
          FormUtils.submitShowError(config, response);
        }
      }).catch(error => {
        console.log(error);
        FormUtils.submitShowError(config, error.response);
      });
    }
  }

  static submitShowSuccess (config, response) {
    let swalConfig = {
      title: config.successTitle,
      html: DOMPurify.sanitize(config.successText),
      icon: 'success',
      confirmButtonText: 'OK',
      buttonsStyling: true,
      timer: 1000,
      timerProgressBar: true
    };

    if (config.timer) {
      swalConfig.timer = config.timer;
      swalConfig.timerProgressBar = true;
    }

    Vue.swal(swalConfig).then(() => {
      if (config.successAction) {
        config.successAction(response.data);
      }
    }).catch((errors) => {
      console.log(errors);
    });
  }

  static submitShowError (config, response) {
    let errorText = config.errorText;

    if (response && response.data && response.data.errors) {
      let keys = Object.keys(response.data.errors);
      errorText = [];

      for (let i = 0; i < keys.length; i++) {
        errorText.push(response.data.errors[keys[i]]);
      }

      errorText = errorText.join('<br>');
    }

    Vue.swal({
      title: config.errorTitle,
      html: DOMPurify.sanitize(errorText),
      icon: 'error',
      confirmButtonText: 'OK',
      buttonsStyling: true
    }).then(() => {
      if (config.failAction) {
        config.failAction(response);
      }
    });
  }

  static submitInBackground (config) {
    let method = 'post';

    if (config.method) {
      method = config.method;
    }

    config.$http[method](
      config.endpoint,
      config.formData
    ).then(response => {
      config.successAction(response.data);
    }).catch(error => {
      console.log(error);

      if (config.errorTitle || config.errorText) {
        FormUtils.submitShowError(config, error.response);
      } else if (config.failAction) {
        config.failAction(error);
      }
    });
  }
}
